module.exports = __webpack_public_path__ + "static/media/pendingStamp.40f4f7b6.png";